import { withCatalogLayout } from "@/elements-react/catalog-layout/withCatalogLayout";
import { useWhyCustomersTrustCommon } from "@/pages-react/why-customers-trust-us/WhyCustomersTrustCommon.tsx";
import { LayoutStyleTypes } from "@/util-react/layout";

export const WhyCustomersTrustMobile = withCatalogLayout((props: { content: string }) => {
  const { renderContent } = useWhyCustomersTrustCommon(props.content);

  return (
    <>
      {renderContent()}
    </>
  );
}, LayoutStyleTypes.TYPE_SM);
